"use client"

import { SquareArrowUpLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareArrowUpLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareArrowUpLeftIcon = component(Icon)({ as: SquareArrowUpLeft })
